import { render } from "./InstructorsView.vue?vue&type=template&id=c808e908"
import script from "./InstructorsView.vue?vue&type=script&lang=js"
export * from "./InstructorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__